import {
  UserGroupsAdapter,
  UserGroupType,
  UsersAdapter,
  UserType,
} from "@validereinc/domain";
import React, { useState } from "react";
import {
  EntityDropdownInput,
  EntityDropdownProps,
} from "./EntityDropdownInput";

export const UsersUserGroupsGroupedDropdownInputMode = {
  USERS: "users",
  GROUPS: "groups",
} as const;

export type UsersUserGroupsGroupedDropdownInputModeType =
  (typeof UsersUserGroupsGroupedDropdownInputMode)[keyof typeof UsersUserGroupsGroupedDropdownInputMode];

export const UsersUserGroupsGroupedDropdownInput = (
  props: Omit<
    EntityDropdownProps<UserType | UserGroupType>,
    "fetchEntityList"
  > & {
    defaultGroup: UsersUserGroupsGroupedDropdownInputModeType;
    onActiveGroupChange?: (isGroup: boolean) => void;
  }
) => {
  const {
    defaultGroup,
    onChange: _,
    onActiveGroupChange,
    ...restProps
  } = props;

  const [activeGroup, setActiveGroup] = useState<string>(defaultGroup);

  const adapter =
    activeGroup === UsersUserGroupsGroupedDropdownInputMode.USERS
      ? UsersAdapter.getList
      : UserGroupsAdapter.getList;

  return (
    <EntityDropdownInput<UserType | UserGroupType>
      isMulti={false}
      onGroupChange={(newGroup) => {
        setActiveGroup(newGroup);

        onActiveGroupChange?.(
          newGroup === UsersUserGroupsGroupedDropdownInputMode.GROUPS
        );
      }}
      groups={[
        { id: UsersUserGroupsGroupedDropdownInputMode.USERS, name: "Users" },
        {
          id: UsersUserGroupsGroupedDropdownInputMode.GROUPS,
          name: "User Groups",
        },
      ]}
      defaultGroup={defaultGroup}
      fetchEntityList={adapter}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...restProps}
    />
  );
};
